import { ProgressBar } from "@narmi/design_system";
import { Outlet, useLocation } from "react-router";
import { useFlowType } from "@lending/hooks/useFlowType";
import { useProductType } from "@lending/hooks/useProductType";
import { useFlowProgressPercentage } from "@lending/navigation";
import styles from "./ProgressBarLayout.module.css";

function ProgressBarLayout() {
  const location = useLocation();
  const pathname = location.pathname.replace(/\/$/, ""); // trim trailing slash
  const productType = useProductType();
  const flowType = useFlowType();

  const progressPercentage = useFlowProgressPercentage(pathname, productType, flowType);

  return (
    <div className={styles.progressBarLayoutContainer}>
      <ProgressBar percentComplete={progressPercentage} size="m" fullBleed />
      <div className={styles.outletContainer}>
        <Outlet />
      </div>
    </div>
  );
}

export { ProgressBarLayout };
